import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { common } from '@qwyk/models';

import { ShipmentPackage } from './shipment-packages.models';
import * as ShipmentPackagesActions from './shipment-packages.actions';

export const SHIPMENTPACKAGES_FEATURE_KEY = 'shipmentPackages';

export interface State extends EntityState<ShipmentPackage> {
    selectedId?: string | number; // which ShipmentPackages record has been selected
    loading: boolean; // has the ShipmentPackages list been loaded
    error?: string | null; // last known error (if any)
    pagination?: common.PaginationMeta;
}

export interface ShipmentPackagesPartialState {
    readonly [SHIPMENTPACKAGES_FEATURE_KEY]: State;
}

export const shipmentPackagesAdapter: EntityAdapter<ShipmentPackage> =
    createEntityAdapter<ShipmentPackage>();

export const initialState: State = shipmentPackagesAdapter.getInitialState({
    // set initial required properties
    loading: false,
});

const shipmentPackagesReducer = createReducer(
    initialState,
    on(
        ShipmentPackagesActions.loadShipmentPackages,
        (state) =>
            shipmentPackagesAdapter.removeAll({
                ...state,
                loading: true,
                error: null,
                pagination: null,
            })
    ),
    on(
        ShipmentPackagesActions.loadShipmentPackagesSuccess,
        (state, { shipmentPackages, pagination }) =>
            shipmentPackagesAdapter.setAll(shipmentPackages, {
                ...state,
                loading: false,
                pagination
            })
    ),
    on(ShipmentPackagesActions.updateShipmentPackage, state => ({
        ...state,
        loading: true,
    })),
    on(
        ShipmentPackagesActions.updateShipmentPackageSuccess,
        (state, { shipmentPackage }) =>
            shipmentPackagesAdapter.setOne(shipmentPackage, {
                ...state,
                loading: false,
                selectedId: null,
            })
    ),
    on(
        ShipmentPackagesActions.loadShipmentPackagesFailure,
        ShipmentPackagesActions.updateShipmentPackageFailure,
        (state, { error }) => ({ ...state, error, loading: false })
    ),
    on(
        ShipmentPackagesActions.selectShipmentPackage,
        (state, { shipmentPackage }) => ({
            ...state,
            selectedId: shipmentPackage.id,
        })
    ),
    on(ShipmentPackagesActions.unselectShipmentPackage, state => ({
        ...state,
        selectedId: null,
    })),
    on(ShipmentPackagesActions.reset, () => initialState)
);

export function reducer(state: State | undefined, action: Action) {
    return shipmentPackagesReducer(state, action);
}
